import React, { useEffect, useMemo, useState } from "react";
import { FieldArray, Form, Formik } from "formik";
import editIcon from "../../Images/edit.svg";
import { create } from "../../DataApi/create";
import { useSession } from "../../authentications/SessionContext";
import { read } from "../../DataApi/read";
import { useLanguage } from "../../Components/LangTranslation/LanguageContext";
import LoaderWrapper from "../Loader/LoaderWrapper";
import { handleResponse } from "../../utilities/handleResponse";
import FormikInput from "../Formik/FormikInput";
import { write } from "../../DataApi/write";
import SVGButton from "../Buttons/SVGButton";
import useConfirmationModal from "../../Components/ConfirmationModal/useConfirmationModal";
import { FormContainer } from "../StyledComponents/FormConatiner/FormContainerStyle";
import useFormikSubmitButton from "../../CustomHooks/useFormikSubmitButton";
import { primaryColor } from "../../utilities/colors";
import newBrandFormValidationSchema from "../../utilities/Validation Schema/NewBrandFormValidationSchema";
import Translator from "./Translator";
import SetTranslation from "./SetTranslations";
import Modal from "../Kanban/Modal/Modal";
import FormikSelect from "../Formik/FormikSelect";
import useListOptions from "../../CustomHooks/useListOptions";
import { findAndAddOption } from "../../utilities/findAndAddOption";
import newAttributeFormValidationSchema from "../../utilities/Validation Schema/NewAttributeFormValidationSchema";
import AttributeValuesTable from "./AttributeValuesTable";
// import { useFormikContext } from "formik";

const NewAttribute = ({
  handleCloseModal,
  selectedRecord = {},
  refetchData,
  defaultEdit,
  setDefaultEdit,
}) => {
  const { sessionInfo = true } = useSession();
  const { company_id, context, isVTEX } = sessionInfo;
  // const { setFieldValue, values, errors, touched, setFieldTouched } =
  //   useFormikContext();

  const { language, translations } = useLanguage();
  const t = translations[language];
  const { handleCustomSearch } = useListOptions();

  const [isLoading, setIsLoading] = useState(true);
  const [isColor, setIsColor] = useState(false);
  const [modalType, setModalType] = useState("view");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  const [publicCategList, setPublicCategList] = useState([]);
  const [updatedData, setUpdatedData] = useState([]);

  const { ConfirmationModal, toggleModal, setMetaData, setTitle } =
    useConfirmationModal();

  const { isSubmitting, setIsSubmitting, FormikSubmitButtons } =
    useFormikSubmitButton();

  const [formData, setFormData] = useState({
    name: "",
    category_ids: [],
    value_ids: [],
    attr_values: [],
    isColor: true,
  });
  const modelName = "product.attribute";

  const getPayload = (payload) => {
    return payload;
  };
  const handleAddAttribute = async (values) => {
    const payload = getPayload(values);
    // console.log("payload ", payload);
    // Initialize the apiPayload structure
    let apiPayload = {
      name: payload.name || "",
      display_type: "radio",
      create_variant: "always",
      category_ids: [[6, false, payload.category_ids || []]],
      vtex_group_id: false,
      vtex_spec_id: false,
    };

    // If attr_values exists and is not empty, add value_ids to apiPayload
    if (payload.attr_values && payload.attr_values.length > 0) {
      const valueIds = payload.attr_values.map((item, index) => [
        0,
        item.id,
        {
          sequence: index, // The sequence will be the index in the attr_values array
          name: item.name,
          hexCode: item.hexCode,
          is_custom: false,
          html_color: false,
        },
      ]);

      apiPayload.value_ids = valueIds; // Add value_ids if attr_values exists and has items
    } else {
      // If attr_values is empty, set value_ids to an empty array
      apiPayload.value_ids = [];
    }
    let response = await create({
      payload: apiPayload,
      context,
      company_id,
      model: modelName,
    });
    response = JSON.parse(response);
    if (response?.result) {
      handleCloseModal();
    }
    return response;
  };
  const handleEditForm = async (values) => {
    const newChanges = {};
    const oldPayload = getPayload(formData);
    const newPayload = getPayload(values);
    // console.log("write api", oldPayload, newPayload);

    // Handle changes for name
    if (newPayload["name"] !== oldPayload["name"]) {
      newChanges["name"] = newPayload["name"];
    }

    // Handle changes for category_ids
    if (
      JSON.stringify(newPayload["category_ids"]) !==
      JSON.stringify(oldPayload["category_ids"])
    ) {
      newChanges["category_ids"] = [[6, false, newPayload["category_ids"]]];
    }

    // Handle changes for attr_values (value_ids)
    if (newPayload["attr_values"]) {
      const attrChanges = [];

      // Process all items in the newPayload's attr_values
      newPayload["attr_values"].forEach((item, index) => {
        if (item.id?.toString().startsWith("virtual_")) {
          // Handle new virtual items with the exact format
          attrChanges.push([
            0,
            item.id,
            {
              sequence: index,
              name: item.name,
              hexCode: item.hexCode,
              is_custom: false,
              html_color: false,
            },
          ]);
        } else {
          // Compare existing items with oldPayload
          const oldItem = oldPayload["attr_values"]?.find(
            (old) => old.id === item.id
          );

          if (!oldItem) {
            // If the item doesn't exist in the oldPayload, it's a new item
            attrChanges.push([
              0,
              item.id,
              {
                sequence: index,
                name: item.name,
                hexCode: item.hexCode,
                is_custom: false,
                html_color: false,
              },
            ]);
          } else if (JSON.stringify(oldItem) !== JSON.stringify(item)) {
            // If there’s a change in the item, we log it as [1, id, {modified item}]
            attrChanges.push([
              1,
              item.id,
              { name: item.name, hexCode: item.hexCode },
            ]);
          } else {
            // If the item hasn't changed, we log it as [4, id, false]
            attrChanges.push([4, item.id, false]);
          }
        }
      });

      // If there are any changes in attr_values, add them to newChanges
      if (attrChanges.length > 0) {
        newChanges["value_ids"] = attrChanges;
      }
    }

    // console.log("new changes", newChanges);
    if (Object.keys(newChanges).length === 0) {
      handleCloseModal();
      return false;
    }
    // console.log("new changes", newChanges);
    let response = await write({
      id: selectedRecord?.id,
      change: newChanges,
      company_id,
      context,
      model: modelName,
    });
    response = JSON.parse(response);
    if (response?.result) {
      // console.log("write resp", response);
      handleCloseModal();
      // refetchData();
    }
    return response;
  };

  const handleSubmitForm = async (...args) => {
    const [values, { setFieldError, setFieldTouched, setFieldValue }] = args;
    try {
      // values.attr_values.forEach((_, index) => {
      //   setFieldValue(`attr_values.${index}.isColor`, isColor);
      // });
      // console.log("Updated Values Before Submit:", values);
    } catch (error) {
      console.error("Submission Error:", error);
    }

    setIsSubmitting(true);
    let response = {};
    let successMessage = "Attribute Created Successfully";

    if (modalType === "edit") {
      successMessage = "Attribute Edited Successfully";
      response = await handleEditForm(...args);
    } else if (modalType === "add") {
      response = await handleAddAttribute(...args);
    }
    setIsSubmitting(false);
    handleResponse({
      response,
      setMetaData,
      setTitle,
      successMessage,
    });
    toggleModal();
  };

  const fetchAttributeDetails = async () => {
    let response = await read({
      id: selectedRecord.id,
      change: ["name", "category_ids", "value_ids"],
      context,
      company_id,
      model: modelName,
    });
    response = JSON.parse(response);
    if (response?.result) {
      response = response?.result[0];
      // console.log("initial brand read resp", response);
      setFormData({
        ...response,
        name: response?.name,
        category_ids: response?.category_ids,
        value_ids: response?.value_ids,
        attr_values: [],
      });
      if (response?.value_ids?.length > 0) {
        let attr_response = await read({
          id: response?.value_ids,
          change: [
            "sequence",
            "name",
            "hexCode",
            "display_type",
            "is_custom",
            "html_color",
          ],
          context,
          company_id,
          model: "product.attribute.value",
        });
        attr_response = JSON.parse(attr_response);
        // console.log("attr_response", attr_response);
        if (attr_response?.result) {
          const processedAttrValues = attr_response.result.map((item) => ({
            display_type: item.display_type,
            hexCode: item.hexCode,
            html_color: item.html_color,
            id: item.id,
            is_custom: item.is_custom,
            name: item.name,
            sequence: item.sequence,
          }));

          // console.log("Processed attr_values", processedAttrValues);

          setFormData((prevState) => ({
            ...prevState,
            attr_values: processedAttrValues,
          }));
        }
      }
      setIsLoading(false);
      return response;
    }
  };

  useEffect(() => {
    if (selectedRecord?.id) {
      setModalType("view");
      fetchAttributeDetails(); // fetches and sets formData
    } else {
      setModalType("add");
      setFormData({
        name: "",
        category_ids: [],
        value_ids: [],
        attr_values: [],
      });
      setIsLoading(false);
    }
  }, [selectedRecord?.id]); // No dependency on formData here

  // Separate effect to handle when formData updates
  useEffect(() => {
    // console.log("formData updated:", formData);
    // Perform actions based on updated formData
  }, [formData]);
  useEffect(() => {
    if (modalType === "edit") {
      // console.log("attribute edit mode");
    }
    handleCustomSearch({
      model: "product.public.category",
      args: [
        ["parent_id", "=", false],
        ["vtexAdminCateg", "=", true],
      ],
      setState: setPublicCategList,
    });
  }, [modalType]);

  const disableInputs = useMemo(() => modalType === "view", [modalType]);
  // console.log("disableInputs", disableInputs, modalType);
  return (
    <>
      <ConfirmationModal />
      {isCreateModalOpen && (
        <Modal isOpen={isCreateModalOpen} onClose={handleCloseModal}>
          <SetTranslation
            handleCloseModal={(modalValue) => setIsCreateModalOpen(false)}
            data={updatedData}
          />
        </Modal>
      )}
      <Formik
        enableReinitialize
        initialValues={formData}
        validationSchema={newAttributeFormValidationSchema}
        onSubmit={handleSubmitForm}
      >
        {({
          values,
          errors,
          touched,
          setFieldValue,
          validateForm,
          setErrors,
          setFieldTouched,
        }) => (
          <Form>
            <div
              className={`container ${modalType === "view" ? "mb-4" : ""}`}
              style={{ width: "1000px", padding: "10px" }}
            >
              <FormContainer className="row g-3">
                <div className="row p-0 justify-content-between align-items-center">
                  <div className="col">
                    <h3
                      className="me-2 mb-2 "
                      style={{
                        fontFamily: "Inter",
                        color: "#323B4B",
                        fontWeight: 600,
                      }}
                    >
                      {modalType === "add" && t["Add New Attribute"]}
                      {modalType === "edit" && t["Edit Attribute"]}
                      {modalType === "view" && t["Attribute"]}
                    </h3>
                  </div>
                  {modalType === "view" && (
                    <div className="col d-flex justify-content-end p-0">
                      <SVGButton
                        hoverColor={isVTEX ? primaryColor.primary : "#ff5837"}
                        icon={editIcon}
                        onClick={() => {
                          setModalType("edit");
                        }}
                        className="me-2"
                      />
                    </div>
                  )}
                </div>
                <LoaderWrapper
                  isLoading={isLoading}
                  height="70vh"
                  width="800px"
                >
                  <div className="d-flex flex-column justify-content-center align-items-start col-12 gap-3">
                    <div className="col-6 d-flex flex-column gap-3">
                      <div className="col-12" style={{ position: "relative" }}>
                        {!disableInputs && modalType === "edit" && (
                          <Translator
                            productId={selectedRecord?.id || ""}
                            modelSpecific={"product.attribute"}
                            color={primaryColor.primary}
                            fieldName={"name"}
                            fieldValue={values.name}
                            isCreateModalOpen={isCreateModalOpen}
                            setIsCreateModalOpen={setIsCreateModalOpen}
                            updatedData={updatedData}
                            setUpdatedData={setUpdatedData}
                          />
                        )}
                        <FormikInput
                          disabled={disableInputs}
                          name="name"
                          label={t["Attribute Name"]}
                        />
                      </div>
                    </div>
                    <div className="col-6">
                      <FormikSelect
                        disabled={disableInputs}
                        options={publicCategList}
                        placeholder="Search or Select..."
                        name="category_ids"
                        label="Category"
                        handleSearch={({ ...args }) =>
                          handleCustomSearch({
                            ...args,
                            model: "product.public.category",
                          })
                        }
                        onChange={(op) => {
                          // console.log(op, "VtexBrand");
                          findAndAddOption({
                            incomingOption: [op.value, op.label],
                            setAvailableOptions: setPublicCategList,
                          });
                        }}
                        isMulti
                      />
                    </div>
                    <div className="d-flex justify-content-center align-items-center">
                      <div className="form-check d-flex justify-content-center align-items-center">
                        <input
                          className="form-check-input isColorCheckbox"
                          type="checkbox"
                          disabled={disableInputs}
                          id="isColor"
                          checked={values.isColor}
                          onChange={(event) =>
                            setFieldValue("isColor", event.target.checked)
                          } // Direct arrow function
                        />
                      </div>
                      <small
                        className="form-check-label text-muted fst-italic"
                        htmlFor="isColor"
                      >
                        Check this box to enable the hex code input for color
                        attributes.
                      </small>
                    </div>
                    <div className="col-12">
                      <FieldArray
                        name="attr_values"
                        render={({ ...props }) => {
                          return (
                            <AttributeValuesTable
                              uesTable
                              {...props}
                              disabled={disableInputs}
                              modelSpecific={"product.attribute.value"}
                              color={primaryColor.primary}
                              fieldName={"name"}
                              isCreateModalOpen={isCreateModalOpen}
                              setIsCreateModalOpen={setIsCreateModalOpen}
                              updatedData={updatedData}
                              setUpdatedData={setUpdatedData}
                              modalType={modalType}
                              isColor={isColor}
                              touched={touched}
                              errors={errors}
                            />
                          );
                        }}
                      />
                    </div>
                  </div>
                  {/* <ErrorFocus /> */}

                  {!disableInputs && (
                    <FormikSubmitButtons handleCloseModal={handleCloseModal} />
                  )}
                </LoaderWrapper>
              </FormContainer>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default NewAttribute;
